import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppState } from '../../../store';
import {
  createEdge,
  createEdgeEndDrag,
  duplicateComponentsAction,
  hoverComponent,
  openComponentsModal,
  removeComponents,
  resizeNoteComponent,
  resizeNoteComponentTemp,
  selectComponents,
  updateComponentPosition,
  updateComponentTempPosition,
  updateEdgeTempPosition,
} from '../../store/package-designer.actions';
import { COMPONENT_CATEGORY, ComponentTypeItem } from '../../../constants/component_types';
import { DESIGNER_SETTINGS } from '../../../constants/designer_settings';
import {
  selectComponentInputEdgesLength,
  selectComponentOutputEdgesLength,
  selectFixedComponentById,
  selectIsDraggingFlag,
  selectTempComponenSizeById,
  selectTempComponentPositionById,
} from '../../store/package-designer.selectors';
import { COMPONENT_TYPE } from '../../../constants/component_type';

@Component({
  selector: 'xp-designer-package-item',
  template: `
    <svg
      *ngIf="component && component.id"
      class="designer-component"
      [attr.height]="isHover ? '156px' : '111px'"
      [attr.width]="isHover ? '184px' : '140px'"
      [id]="component.id"
      [ngClass]="{
        hover: isHover,
        connectable: (selectIsDraggingFlag$ | async) && isHover,
        selected: component.isSelected
      }"
      cdkDrag
      cdkDragBoundary=".designer-scroll"
      (cdkDragStarted)="onDragStarted()"
      (cdkDragMoved)="onDragMoved($event)"
      (cdkDragEnded)="onDragEnded($event)"
      [cdkDragFreeDragPosition]="dragPosition"
    >
      <g *ngIf="component.componentType !== COMPONENT_TYPE.STICKY_NOTE_COMPONENT" (mouseleave)="onMouseLeave()">
        <g class="designer-component-port-source" *ngIf="component.outputMin > 0">
          <rect width="10" height="8"></rect>
        </g>

        <path
          class="designer-component-hover"
          *ngIf="isHover"
          d="M140,0c-24.3,0-44,19.7-44,44H0v81.7v-1c0,2.2,1.9,4.3,4.1,4.3h132c2.2,0,3.9-2.1,3.9-4.3V88c24.3,0,44-19.7,44-44
    S164.3,0,140,0z"
        ></path>
        <g class="designer-component-background" (mouseenter)="onMouseEnter()">
          <pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="15" height="15">
            <rect width="15" height="15" fill="#FFF" />
            <line x1="0" y1="15" x2="15" y2="0" stroke="black" stroke-width="1" opacity="0.2" stroke-linecap="round" />
          </pattern>
          <rect
            class="designer-component-bg-new"
            width="140"
            height="84"
            rx="4"
            ry="4"
            [attr.fill]="isValid ? '#fff' : 'url(#diagonalHatch)'"
            [attr.opacity]="isValid ? '1' : '0.75'"
            cdkDragHandle
            (click)="editComponent()"
          ></rect>
          <path
            class="designer-component-border"
            d="M136,3c0.6,0,1,0.4,1,1v76c0,0.6-0.4,1-1,1H4c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1H136 M136,0H4
            C1.8,0,0,1.8,0,4v76c0,2.2,1.8,4,4,4h132c2.2,0,4-1.8,4-4V4C140,1.8,138.2,0,136,0L136,0z"
          ></path>
        </g>
        <g class="designer-component-edit">
          <rect class="designer-component-edit-hit-area"></rect>
          <text class="designer-component-edit-text">EDIT</text>
        </g>
        <g
          #componentAdd
          class="designer-component-add"
          *ngIf="outputEdgesLength < component.outputMax"
          (click)="addComponent()"
          cdkDrag
          (cdkDragStarted)="onDragStartedAdd()"
          (cdkDragMoved)="onDragMovedAdd($event)"
          (cdkDragEnded)="onDragEndedAdd()"
          [ngClass]="{ invisible: isDraggingAdd }"
        >
          <rect></rect>
          <path d="M136,4H4C1.8,4,0,2.2,0,0v0h140v0C140,2.2,138.2,4,136,4z"></path>
          <polygon points="13,5 8,5 8,0 5,0 5,5 0,5 0,8 5,8 5,13 8,13 8,8 13,8 "></polygon>
        </g>
        <text class="designer-component-name" text-anchor="middle" x="70" y="67">{{ name }}</text>
        <use
          class="designer-component-icon"
          width="32"
          height="32"
          [attr.href]="'#icons-sprite_' + component.icon"
        ></use>
        <g class="designer-component-remove" (mousedown)="remove($event)">
          <circle class="designer-component-circle-bg" cx="22" cy="22" r="18"></circle>
          <circle class="designer-component-circle-border" cx="22" cy="22" r="18"></circle>
          <polygon
            class="designer-component-circle-icon"
            points="27.8,18 26,16.2 22,20.2 18,16.2 16.2,18 20.2,22 16.2,26 18,27.8 22,23.8 26,27.8 27.8,26 23.8,22 "
          ></polygon>
        </g>
        <g class="designer-component-duplicate" (mousedown)="duplicate()">
          <circle class="designer-component-circle-bg" cx="22" cy="22" r="18"></circle>
          <circle class="designer-component-circle-border" cx="22" cy="22" r="18"></circle>
          <polygon class="designer-component-circle-icon" points="18,19 18,23 13,23 13,14 25,14 25,19 "></polygon>
          <rect class="designer-component-circle-icon" x="19" y="20" width="12" height="9"></rect>
        </g>
        <g class="designer-component-port-target" *ngIf="component.inputMin > 0">
          <polygon points="7,0 7,3 3,3 3,0 0,0 0,3 0,6 0,8 10,8 10,6 10,3 10,0 "></polygon>
        </g>
      </g>
      <g class="designer-note" *ngIf="component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT">
        <pattern id="note-bg" width="7" height="22" patternUnits="userSpaceOnUse">
          <rect width="7" height="22" fill="#FFF" />
          <line style="stroke: #ddd; stroke-miterlimit: 10; stroke-width: 1;" x1="0" y1="7" x2="5" y2="7" />
        </pattern>
        <rect
          #noteBody
          class="designer-note-body"
          width="208"
          height="160"
          (mousedown)="editComponent()"
          [attr.fill]="'url(#note-bg)'"
        />
        <rect class="designer-note-header" #noteHeader width="208" height="41" cdkDragHandle />
        <g class="designer-note-remove" #noteRemove (mousedown)="remove($event)">
          <rect class="designer-note-bg" width="12" height="12" />
          <line x1="1.1" y1="1.1" x2="11.1" y2="11.1" />
          <line x1="1.1" y1="11.1" x2="11.1" y2="1.1" />
        </g>
        <g class="designer-note-duplicate" (mousedown)="duplicate()">
          <rect class="designer-note-bg" width="12" height="12" />
          <polygon points="5,5 5,9 0,9 0,0 12,0 12,5 	" />
          <rect x="6" y="6" width="12" height="9" />
        </g>
        <g class="designer-note-title" #noteTitle>
          <text>Note</text>
        </g>
        <foreignObject #foreignObject x="10" y="51" width="188" height="160">
          <p #noteText xmlns="http://www.w3.org/1999/xhtml">{{ noteDescription }}</p>
        </foreignObject>
        <g
          #noteResize
          class="designer-note-resize"
          *ngIf="component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT"
          cdkDrag
          (cdkDragStarted)="onDragStartedResize()"
          (cdkDragMoved)="onDragMovedResize($event)"
          (cdkDragEnded)="onDragEndedResize()"
        >
          <rect width="20" height="20"></rect>
        </g>
      </g>
    </svg>
  `,
})
export class DesignerPackageItemComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() componentId: string;
  @ViewChild('noteText') noteText: ElementRef<HTMLElement>;
  @ViewChild('noteBody') noteBody: ElementRef<HTMLElement>;
  @ViewChild('foreignObject') foreignObject: ElementRef<HTMLElement>;
  @ViewChild('noteHeader') noteHeader: ElementRef<HTMLElement>;
  @ViewChild('noteRemove') noteRemove: ElementRef<HTMLElement>;
  @ViewChild('noteTitle') noteTitle: ElementRef<HTMLElement>;
  @ViewChild('noteResize') noteResize: ElementRef<HTMLElement>;
  @ViewChild('componentAdd') componentAdd: ElementRef<HTMLElement>;
  component: Partial<ComponentTypeItem> = {};

  isHover = false;
  isDragging = false;
  isDraggingAdd = false;
  isDraggingResize = false;
  noteInitialWidth = 0;
  noteInitialHeight = 0;

  inputEdgesLength: number = 0;
  outputEdgesLength: number = 0;
  tempOutputEdgesLength: number = 0;
  componentSubscription: Subscription;
  componentTempPositionSubscription: Subscription;
  componentTempSizeSubscription: Subscription;
  inputEdgesLengthSubscription: Subscription;
  outputEdgesLengthSubscription: Subscription;
  lastDistanceX = 0;
  lastDistanceY = 0;
  dragPosition = { x: 0, y: 0 };
  selectIsDraggingFlag$ = this.store.select(selectIsDraggingFlag);
  COMPONENT_TYPE = COMPONENT_TYPE;
  isWorkflow = false;
  noteDescription = '';

  constructor(private store: Store<AppState>) {}

  ngAfterViewInit() {
    if (this.component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT) {
      this.updateNoteDimensions(this.component.noteHeight, this.component.noteWidth);
    }
  }

  ngOnInit() {
    this.componentSubscription = this.store
      .select(selectFixedComponentById(this.componentId))
      .pipe(filter(Boolean))
      .subscribe((component: ComponentTypeItem) => {
        if (this.component.description !== component.description) {
          // @ts-ignore
          this.noteDescription = component.description.replaceAll('<br />', '\n');
          this.updateNoteDimensions();
        }

        if (this.component.noteHeight !== component.noteHeight || this.component.noteWidth !== component.noteWidth) {
          setTimeout(() => {
            this.updateNoteDimensions(component.noteHeight, component.noteWidth);
          });
        }

        this.component = component;
        this.isWorkflow = component.type === COMPONENT_CATEGORY.workflow;

        if (!this.isDragging) {
          this.dragPosition = {
            x: this.component.xy[0],
            y:
              this.component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT
                ? this.component.xy[1] + 43
                : this.component.xy[1] - DESIGNER_SETTINGS.TOP_MARGIN_CELL + 43,
          };
        }

        if (this.inputEdgesLengthSubscription) {
          this.inputEdgesLengthSubscription.unsubscribe();
        }
        this.inputEdgesLengthSubscription = this.store
          .select(selectComponentInputEdgesLength(this.component.id))
          .subscribe((inputEdgesLength) => {
            this.inputEdgesLength = inputEdgesLength;
          });

        if (this.outputEdgesLengthSubscription) {
          this.outputEdgesLengthSubscription.unsubscribe();
        }
        this.outputEdgesLengthSubscription = this.store
          .select(selectComponentOutputEdgesLength(this.component.id))
          .subscribe((outputEdgesLength) => {
            if (!this.isDraggingAdd) {
              this.outputEdgesLength = outputEdgesLength;
            } else {
              this.tempOutputEdgesLength = outputEdgesLength;
            }
          });
      });

    this.componentTempPositionSubscription = this.store
      .select(selectTempComponentPositionById(this.componentId))
      .pipe(filter(Boolean))
      .subscribe((coords) => {
        if (this.component.isSelected && !this.isDragging) {
          this.dragPosition = {
            x: coords[0],
            y:
              this.component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT
                ? coords[1] + 43
                : coords[1] - DESIGNER_SETTINGS.TOP_MARGIN_CELL + 43,
          };
        }
      });

    this.componentTempSizeSubscription = this.store
      .select(selectTempComponenSizeById(this.componentId))
      .pipe(filter(Boolean))
      .subscribe((sizes) => {
        this.updateNoteDimensions(sizes[0], sizes[1]);
      });
  }

  updateNoteDimensions(height?: number, width?: number) {
    if (this.noteText?.nativeElement) {
      const descriptionHeight = height || this.noteText.nativeElement.offsetHeight;

      this.foreignObject.nativeElement.setAttribute('height', `${descriptionHeight}`);
      this.noteBody.nativeElement.setAttribute(
        'height',
        `${descriptionHeight + DESIGNER_SETTINGS.NOTE_PADDING_HORIZONTAL}`,
      );
      let descriptionWidth = width || this.noteText.nativeElement.offsetWidth;

      if (descriptionWidth < 188) {
        descriptionWidth = 188;
      }

      this.foreignObject.nativeElement.setAttribute('width', `${descriptionWidth}`);
      this.noteBody.nativeElement.setAttribute(
        'width',
        `${descriptionWidth + DESIGNER_SETTINGS.NOTE_PADDING_VERTICAL}`,
      );
      this.noteHeader.nativeElement.setAttribute(
        'width',
        `${descriptionWidth + DESIGNER_SETTINGS.NOTE_PADDING_VERTICAL}`,
      );
      this.noteRemove.nativeElement.setAttribute('style', `transform: translate(${descriptionWidth - 5}px, 14px)`);
      this.noteTitle.nativeElement.setAttribute('style', `transform: translate(${descriptionWidth / 2 + 10}px, 24px)`);
      this.noteResize.nativeElement.setAttribute(
        'style',
        `transform: translate(${descriptionWidth}px, ${descriptionHeight + 35}px)`,
      );
    }
  }

  editComponent() {
    if (this.isDragging) {
      this.isDragging = false;
      return;
    }
    this.store.dispatch(openComponentsModal({ componentId: this.component.id }));
  }

  addComponent() {
    if (this.isDraggingAdd) {
      this.isDraggingAdd = false;
      return;
    }
    this.store.dispatch(
      openComponentsModal({
        parentComponentId: this.component.id,
        flags: {
          hasSources: false,
          hasTransformations: !this.isWorkflow,
          hasDestinations: !this.isWorkflow,
          hasWorkflow: this.isWorkflow,
        },
      }),
    );
  }

  onDragStarted() {
    this.isDragging = true;
    if (!this.component.isSelected) {
      this.store.dispatch(selectComponents({ componentIds: [] }));
    }
  }

  onDragStartedAdd() {
    this.isDraggingAdd = true;
    this.store.dispatch(
      createEdge({
        sourceComponentId: this.component.id,
        x: this.component.xy[0] - DESIGNER_SETTINGS.CELL,
        y: this.component.xy[1] + DESIGNER_SETTINGS.COMPONENT_HEIGHT + 20,
      }),
    );
  }

  onDragMovedAdd(event) {
    const { distance } = event;

    if (this.lastDistanceX === distance.x && this.lastDistanceY === distance.y) {
      return event;
    }

    this.lastDistanceX = distance.x;
    this.lastDistanceY = distance.y;

    this.store.dispatch(
      updateEdgeTempPosition({
        x: this.component.xy[0] + distance.x,
        y: this.component.xy[1] + distance.y + DESIGNER_SETTINGS.COMPONENT_HEIGHT + 20,
        id: this.component.id,
      }),
    );

    return event;
  }

  onDragEndedAdd() {
    this.isDraggingAdd = false;
    this.store.dispatch(createEdgeEndDrag({ sourceComponentId: this.component.id }));
    this.outputEdgesLength = this.tempOutputEdgesLength;
    if (this.component.componentType === COMPONENT_TYPE.CLONE_COMPONENT) {
      this.componentAdd.nativeElement.removeAttribute('transform');
      this.componentAdd.nativeElement.removeAttribute('style');
    }
  }

  onDragStartedResize() {
    this.isDraggingResize = true;
    this.noteInitialWidth = Number(this.noteBody.nativeElement.getAttribute('width'));
    this.noteInitialHeight = Number(this.noteBody.nativeElement.getAttribute('height'));
  }

  onDragMovedResize(event) {
    const { distance } = event;

    if (this.lastDistanceX === distance.x && this.lastDistanceY === distance.y) {
      return;
    }

    this.lastDistanceX = distance.x;
    this.lastDistanceY = distance.y;

    let width = this.noteInitialWidth - DESIGNER_SETTINGS.NOTE_PADDING_VERTICAL + distance.x;
    let height = this.noteInitialHeight - DESIGNER_SETTINGS.NOTE_PADDING_HORIZONTAL + distance.y;

    if (width < 188) {
      width = 188;
    }

    if (height < 100) {
      height = 100;
    }

    this.store.dispatch(
      resizeNoteComponentTemp({
        width,
        height,
        id: this.component.id,
      }),
    );
  }

  onDragEndedResize() {
    this.isDraggingResize = false;

    this.store.dispatch(
      resizeNoteComponent({
        width: Number(this.noteBody.nativeElement.getAttribute('width')) - DESIGNER_SETTINGS.NOTE_PADDING_VERTICAL,
        height: Number(this.noteBody.nativeElement.getAttribute('height')) - DESIGNER_SETTINGS.NOTE_PADDING_HORIZONTAL,
        id: this.component.id,
      }),
    );
  }

  get name(): string {
    if (!this.component.name) {
      return '';
    }

    return this.component.name.length > DESIGNER_SETTINGS.MAX_NAME_LENGTH
      ? `${this.component.name.substr(0, DESIGNER_SETTINGS.MAX_NAME_LENGTH)} ..`
      : this.component.name;
  }

  onDragMoved(event) {
    const { distance } = event;

    if (this.lastDistanceX === distance.x && this.lastDistanceY === distance.y) {
      return event;
    }

    this.lastDistanceX = distance.x;
    this.lastDistanceY = distance.y;

    this.store.dispatch(
      updateComponentTempPosition({
        distanceX: distance.x,
        distanceY: distance.y,
        id: this.component.id,
      }),
    );

    return event;
  }

  onDragEnded({ distance }) {
    if (this.component.componentType === COMPONENT_TYPE.STICKY_NOTE_COMPONENT) {
      this.isDragging = false;
    }

    this.store.dispatch(
      updateComponentPosition({
        distanceX: distance.x,
        distanceY: distance.y,
        id: this.component.id,
      }),
    );
  }

  onMouseEnter() {
    if (!this.isHover) {
      this.isHover = true;
      this.store.dispatch(hoverComponent({ componentId: this.component.id, isHovered: true }));
    }
  }

  onMouseLeave() {
    if (this.isHover) {
      this.isHover = false;
      this.store.dispatch(hoverComponent({ componentId: this.component.id, isHovered: false }));
    }
  }

  get isValid(): boolean {
    return this.outputEdgesLength >= this.component.outputMin && this.inputEdgesLength >= this.component.inputMin;
  }

  remove(event) {
    event.stopImmediatePropagation();
    this.store.dispatch(removeComponents({ componentId: this.component.id }));
  }

  duplicate() {
    this.store.dispatch(duplicateComponentsAction({ componentId: this.component.id }));
  }

  ngOnDestroy() {
    if (this.componentSubscription) {
      this.componentSubscription.unsubscribe();
    }

    if (this.componentTempPositionSubscription) {
      this.componentTempPositionSubscription.unsubscribe();
    }

    if (this.inputEdgesLengthSubscription) {
      this.inputEdgesLengthSubscription.unsubscribe();
    }

    if (this.outputEdgesLengthSubscription) {
      this.outputEdgesLengthSubscription.unsubscribe();
    }

    if (this.componentTempSizeSubscription) {
      this.componentTempSizeSubscription.unsubscribe();
    }
  }
}
